<template>
  <div>
    <div class="header">
      <p>上传短视频</p>
      <div>
        <el-button style="margin-right:20px;color:red;" type="text" @click="delVideo">删除</el-button>
        <el-button style="width:100px" type="primary" @click="submit">发布</el-button>
      </div>
    </div>
    <div class="content_item">
      <div class="title">
        <span>*</span>短视频
      </div>
      <div class="addImg_box" v-if="addVideoShow == 1">
        <img src="@/assets/images/addImages.png" />
        <input type="file" accept="video/*" class="input_upload" @change="changeUpload" />
      </div>
      <div v-if="addVideoShow == 2">
        <el-progress :width="83" type="circle" :percentage="progress"></el-progress>
      </div>
      <div class="video_box" @click="videoShow = true" v-if="addVideoShow == 3">
        <div class="btn" @click.stop>
          <el-button type="text" style="padding:0;">重新上传</el-button>
          <input type="file" accept="video/*" class="input_upload" @change="changeUpload" />
        </div>
        <div class="yulan">预览视频</div>
      </div>
    </div>
    <div class="content_item">
      <div class="title">
        <span>*</span>关联商品
      </div>
      <div v-if="!goodShow">
        <el-input style="width:600px;" placeholder="请填写活动名称，最多30字" maxlength="30">
          <el-button slot="append" @click="selectProducts">选择商品</el-button>
        </el-input>
      </div>
      <div v-if="goodShow" style="display:flex;">
        <div class="good">
          <div class="logo_box">
            <img :src="good.logo" alt />
          </div>
          <div class="text">
            <div>{{good.name}}</div>
            <div>
              <span class="price">￥{{good.price}}</span>
              <span class="employeePrice">
                ￥{{good.employeePrice}}
                <span>园区币</span>
              </span>
            </div>
          </div>
        </div>
        <div class="select" @click="selectProducts">选择商品</div>
      </div>
    </div>
    <!-- <div class="content_item">
      <div class="title">商品描述</div>
      <div class="width:500px;height:200px">
        <el-input
          type="textarea"
          maxlength="50"
          style="width:500px"
          autosize
          placeholder="请输入内容"
          v-model="textarea"
        ></el-input>
      </div>
    </div> -->
    <div id="video_box" @click="videoShow = false" v-if="videoShow">
      <video class="player" width="375" height="633" controls="controls">
        <!-- <source src="movie.ogg" type="video/ogg" /> -->
        <source :src="videoSrc" type="video/mp4" />您的浏览器不支持此种视频格式。
      </video>
    </div>
    <el-dialog title="选择商品" :visible.sync="centerDialogVisible" width="60%" center>
      <div style="margin:20px 0;">
        <el-input
          style="width:300px;"
          placeholder="请输入商品名称\编码"
          maxlength="30"
          v-model="searchValue"
        ></el-input>
        <el-button type="primary" @click="getGoodList(1)">搜索</el-button>
        <el-button type="info" @click="reset">重置</el-button>
      </div>
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column align="center" prop="goodName" label="商品名称"></el-table-column>
        <el-table-column align="center" prop="price" label="售价" width="180"></el-table-column>
        <el-table-column align="center" prop="stock" label="库存" width="180"></el-table-column>
        <el-table-column align="center" prop="address" label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="addsgood(scope.row)">选择商品</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @current-change="pageFn()"
        layout="prev, pager, next"
        :current-page.sync="currentPage"
        :page-size="10"
        :total="goodsCount"
      ></el-pagination>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="centerDialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// var COS = require("");
import COS from "cos-js-sdk-v5";
import {
  getUploadToken,
  getSeckillGood,
  releaseVideo,
  delVideo,
} from "@/api/goods";
import { mapGetters } from "vuex";


export default {
  data() {
    return {
      addVideoShow: 1,
      videoShow: false,
      videoSrc: "",
      cos: {},
      centerDialogVisible: false,
      currentPage: 1,
      goodsCount: 10,
      tableData: [],
      searchValue: "",
      good: {},
      goodShow: false,
      textarea: "",
      progress: 0,
    };
  },
  mounted() {
    if (typeof this.$route.query.goodId == "undefined") {
      console.log(123);
    } else {
      (this.videoSrc = this.$route.query.goodVideo),
        (this.textarea = this.$route.query.desc);
      this.good = {
        price: this.$route.query.price / 100,
        name: this.$route.query.goodName,
        id: this.$route.query.goodId,
        logo: this.$route.query.logo,
        employeePrice: this.$route.query.employeePrice / 100,
      };
      this.addVideoShow = 3;
      this.goodShow = true;
      console.log(this.good)
    }
    this.cos = new COS({
      getAuthorization: function (options, callback) {
        // 异步获取临时密钥
        getUploadToken().then(function (res) {
          if (res.code === 1) {
            callback({
              TmpSecretId: res.data.credentials.tmpSecretId, // 临时密钥的 tmpSecretId
              TmpSecretKey: res.data.credentials.tmpSecretKey, // 临时密钥的 tmpSecretKey
              XCosSecurityToken: res.data.credentials.sessionToken, // 临时密钥的 sessionToken
              ExpiredTime: res.data.expiredTime, // 临时密钥失效时间戳，是申请临时密钥时，时间戳加 durationSeconds
            });
          } else {
            throw "get tencent upload key error";
          }
        });
      },
    });
  },
  computed: {
    ...mapGetters(["chooseCompany", "companyList", "mchId"]),
  },
  methods: {
    changeUpload(event) {
      let that = this;
      let file = event.target.files[0];
      this.cos.sliceUploadFile(
        {
          Bucket: "range-smartpark-1257239906" /* 必须 */,
          Region: "ap-beijing" /* 存储桶所在地域，必须字段 */,
          Key: file.name /* 必须 */,
          StorageClass: "STANDARD",
          Body: file, // 上传文件对象 
          onTaskReady: function (taskId) {
            that.addVideoShow = 2;
            //监听任务创建showRightMenu
            // 任务开始
            console.log(taskId);
          },
          onProgress: function (progressData) {
            //   进度
            that.progress = progressData.percent * 100;
            console.log(progressData);
          },
        },
        function (err, data) {
          //MaskUtil.unmask();	#上传成功关闭加载效果
          console.log(err, data);
          //在这里做回调成功的操作，比如我上传视频，成功之后，删除input框，并且显示video框，并给video框的src属性赋值
          if (typeof data == "undefined") {
            alert("上传失败！");
            return false;
          }
          if (data.statusCode != 200) {
            alert("错误[" + data.statusCode + "]");
            return false;
          }

          //把路径复制给表单
          that.videoSrc = "https://cdn.shop.rangepark.cn/" + file.name;
          that.addVideoShow = 3;
        }
      );
    },
    submit() {
      if (this.videoSrc == "") {
        this.$message({
          type: "info",
          message: "请先上传视频",
        });
        return;
      } else if (typeof this.good.id == "undefined") {
        this.$message({
          type: "info",
          message: "请先上传上传商品",
        });
        return;
      }
      let data = {
        goodId: this.good.id,
        goodVideo: this.videoSrc,
        desc:"",
      };
      // if (typeof this.textarea == "undefined") {
      //   data.desc = "";
      // } else {
      //   data.desc = this.textarea;
      // }
      releaseVideo(data).then((res) => {
        if (res.code == 1) {
          this.$message({
            message: "添加成功",
            type: "success",
          });
          this.$router.go(-1);
        }
      });
    },
    delVideo() {
      delVideo(this.good.id).then((res) => {
        if (res.code == 1) {
          this.$router.go(-1);
          this.$message({
            message: "删除成功",
            type: "success",
          });
        }
      });
    },
    selectProducts() {
      this.centerDialogVisible = true;
      this.getGoodList();
    },
    getGoodList(page) {
      let mchId = this.chooseCompany.id;
      let data = {
        pageCount: 10,
        page: this.currentPage,
        goodName: this.searchValue,
        mchId:mchId,
      };
      if(page){
        console.log(1)
        data.page = page;
      }
      getSeckillGood(data).then((res) => {
        let count = res.data.pop();
        if (typeof count != "undefined") {
          this.goodsCount = count.goodsCount;
        }
        this.tableData = res.data;
      });
    },
    addsgood(data) {
      this.listPush = false;
      this.good = {
        price: data.price / 100,
        name: data.goodName,
        id: data.goodId,
        logo: data.logo,
        employeePrice: data.employeePrice / 100,
      };
      console.log(this.good);
      this.goodShow = true;
      this.centerDialogVisible = false;
    },
    pageFn() {
      this.getGoodList();
    },
    reset() {
      this.searchValue = "";
      this.getGoodList();
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  // width: 100%;
  padding: 0 60px;
  display: flex;
  justify-content: space-between;
}
.content_item {
  padding: 20px 60px;
  display: flex;
  align-items: center;
  // justify-content: center;
  .title {
    width: 80px;
    text-align: right;
    padding: 20px;
    span {
      color: red;
    }
  }
  .addImg_box {
    width: 43px;
    height: 43px;
    padding: 20px;
    border: 1px solid #b5b5b5;
    position: relative;
    img {
      width: 43px;
      height: 43px;
    }
  }
  .video_box {
    width: 43px;
    height: 63px;
    padding: 10px 20px;
    background-color: #eee;
    position: relative;

    .yulan {
      position: absolute;
      left: 0;
      bottom: 0;
      height: 20px;
      background-color: rgba(0, 0, 0, 0.3);
      width: 100%;
      text-align: center;
      color: #fff;
      font-size: 12px;
    }
    .btn {
      position: absolute;
      height: 20px;
      //   width: 100px;
      top: 50%;
      left: 100px;
      margin-top: -10px;
      padding: 0;
    }
  }
}
#video_box {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 100;
  background-color: rgba(0, 0, 0, 0.3);
  .player {
    margin: 0 auto;
    position: absolute;
    left: 50%;
    top: 40px;
    margin-left: -187px;
    background-color: #000;
  }
}
.good {
  width: 500px;
  height: 80px;
  padding: 10px;
  border: 1px solid #eee;
  display: flex;

  .logo_box {
    width: 80px;
    height: 80px;
    margin-right: 20px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .text {
    display: flex;
    width: 400px;
    flex-direction: column;
    justify-content: space-between;
    .price {
      color: red;
    }
    .employeePrice {
      color: orange;
      margin-left: 20px;
      span {
        color: #fff;
        background-color: gray;
        font-size: 12px;
      }
    }
  }
}
.select {
  width: 80px;
  height: 100px;
  background-color: #7f7f7f;
  color: #fff;
  text-align: center;
  line-height: 100px;
  cursor: pointer;
}
.input_upload {
  width: 100%;
  opacity: 0;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
}
</style>


// WEBPACK FOOTER //
// src/pages/videoShop/addVideo.vue